import React from "react";

import SharedTypeSelector from "./ItemDetailsForm/SharedTypeSelector";
import SpecialtyCakeFields from "./ItemDetailsForm/SpecialtyCakeFields";
import StandardCakeFields from "./ItemDetailsForm/StandardCakeFields";
import CheesecakeFields from "./ItemDetailsForm/CheesecakeFields";
import GrazeBoxFields from "./ItemDetailsForm/GrazeBoxFields";
import PatisserieFields from "./ItemDetailsForm/PatisserieFields";
import SharedPriceQuantityFields from "./ItemDetailsForm/SharedPriceQuantityFields";

const patisserieTypes = [
  "cupcake",
  "macaron",
  "cakeSlice",
  "cheesecakeSlice",
  "cookie",
  "pastry",
];

const ItemDetailsForm = ({
  item,
  updateItem,
  flavors,
  sizes,
  standardCakes,
  cheesecakes,
  grazeBoxes,
  patisserieItems,
  isStandardDesign,
  setIsStandardDesign,
  rawCents,
  setRawCents,
  getDietExtra,
  calculateGrazeBoxPrice,
}) => {
  const isCakeType = ["standardCake", "specialtyCake"].includes(item.type);
  const isPatisserieType = patisserieTypes.includes(item.type);
  const isGrazeBox = item.type === "grazeBox";

  return (
    <>
      <SharedTypeSelector item={item} updateItem={updateItem} />

      {item.type === "specialtyCake" && (
        <SpecialtyCakeFields item={item} updateItem={updateItem} />
      )}

      {isCakeType && (
        <StandardCakeFields
          item={item}
          updateItem={updateItem}
          flavors={flavors}
          sizes={sizes}
          standardCakes={standardCakes}
        />
      )}

      {item.type === "cheesecake" && (
        <CheesecakeFields
          item={item}
          updateItem={updateItem}
          cheesecakes={cheesecakes}
        />
      )}

      {isGrazeBox && (
        <GrazeBoxFields
          item={item}
          updateItem={updateItem}
          grazeBoxes={grazeBoxes}
          getDietExtra={getDietExtra}
          calculateGrazeBoxPrice={calculateGrazeBoxPrice}
        />
      )}

      {isPatisserieType && (
        <PatisserieFields
          item={item}
          updateItem={updateItem}
          patisserieItems={patisserieItems}
          isStandardDesign={isStandardDesign}
          setIsStandardDesign={setIsStandardDesign}
        />
      )}

      <SharedPriceQuantityFields
        item={item}
        updateItem={updateItem}
        rawCents={rawCents}
        setRawCents={setRawCents}
      />
    </>
  );
};

export default ItemDetailsForm;
